
    import "src/shared/components/NdrCustomerRequests.js/index.module.scss?farm_css_modules";
    
    export default {"downloadButton": `downloadButton-d09a9c23`,"orderStatusFilter": `orderStatusFilter-d09a9c23`,"searchContainer": `searchContainer-d09a9c23`}
    